export const IMAGE_LOADED = 'imagesLoaded'
export const JSON_LOADED = 'jsonLoaded'
export const JSON_LOADING = 'jsonLoading'
export const PAUSE_LOADING = 'pauseLoading'
export const SET_FILTER = 'setFilter'
export const SET_LOCATION = 'setLocation'
export const UPDATE_PATH = 'updatePath'
export const SET_COLOR = 'setColor'
